import entry from './entry';
import tap from './tap';
import plugin from './plugin';
import output from './output';
import loader from './loader';
import alias from './alias';
import root from './root';

export {alias, root, entry, tap, plugin, output, loader};
